// Re-export všetkých typov a služieb pre spätnú kompatibilitu
import { companyService } from './companyService';
import { userService } from './userService';
import { transportService } from './transportService';
import { carrierService } from './carrierService';
import { orderService } from './orderService';
import { generateUniqueId, checkIfExists } from './utils';

export * from './types';
export { generateUniqueId, checkIfExists } from './utils';
export { generateCompanyId, generateOrderId, generateTeamMemberId } from './idGeneratorService';
export { companyService } from './companyService';
export { userService } from './userService';
export { transportService } from './transportService';
export { carrierService } from './carrierService';
export { orderService } from './orderService';
export { invitationService } from './invitationService';
export { reviewService } from './reviewService';

class DatabaseService {
  // Company operations
  async createCompany(companyData: any): Promise<any> {
    return companyService.createCompany(companyData);
  }

  async getCompany(companyId: string): Promise<any> {
    return companyService.getCompany(companyId);
  }

  async getCompanyByEmail(email: string): Promise<any> {
    return companyService.getCompanyByEmail(email);
  }

  async updateCompany(companyId: string, updates: any): Promise<void> {
    return companyService.updateCompany(companyId, updates);
  }

  async deleteCompany(companyId: string): Promise<void> {
    return companyService.deleteCompany(companyId);
  }

  // User operations
  async createUser(userData: any, uid?: string): Promise<any> {
    return userService.createUser(userData, uid);
  }

  async getUser(userId: string): Promise<any> {
    return userService.getUser(userId);
  }

  async updateUser(userId: string, updates: any): Promise<void> {
    return userService.updateUser(userId, updates);
  }

  async getUsersByCompany(companyId: string): Promise<any[]> {
    return userService.getUsersByCompany(companyId);
  }

  // Transport operations
  async createTransport(transportData: any): Promise<any> {
    return transportService.createTransport(transportData);
  }

  async getTransport(transportId: string): Promise<any> {
    return transportService.getTransport(transportId);
  }

  async updateTransport(transportId: string, updates: any): Promise<void> {
    return transportService.updateTransport(transportId, updates);
  }

  async getTransportsByCompany(companyId: string, limitCount: number = 50): Promise<any[]> {
    return transportService.getTransportsByCompany(companyId, limitCount);
  }

  // Carrier operations
  async createCarrier(carrierData: any): Promise<any> {
    return carrierService.createCarrier(carrierData);
  }

  async getCarrier(carrierId: string): Promise<any> {
    return carrierService.getCarrier(carrierId);
  }

  async updateCarrier(carrierId: string, updates: any): Promise<void> {
    return carrierService.updateCarrier(carrierId, updates);
  }

  async searchCarriers(criteria: any): Promise<any[]> {
    return carrierService.searchCarriers(criteria);
  }

  // Order operations
  async createOrder(orderData: any): Promise<any> {
    return orderService.createOrder(orderData);
  }

  async getOrder(orderId: string): Promise<any> {
    return orderService.getOrder(orderId);
  }

  async updateOrder(orderId: string, updates: any): Promise<void> {
    return orderService.updateOrder(orderId, updates);
  }

  async getOrdersByCompany(companyId: string): Promise<any[]> {
    return orderService.getOrdersByCompany(companyId);
  }

  // Utility functions
  async generateUniqueId(collectionName: string, field: string = 'id'): Promise<string> {
    return generateUniqueId(collectionName);
  }

  async checkIfExists(collectionName: string, field: string, value: string): Promise<boolean> {
    return checkIfExists(collectionName, field, value);
  }
}

export const databaseService = new DatabaseService();
export default databaseService;
